(function() { module.exports = this["wp"]["blockLibrary"]; }());